import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import SafeIcon from '../../common/SafeIcon';

const Header = ({ toggleSidebar, isCollapsed, toggleCollapse }) => {
  const [profileOpen, setProfileOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    localStorage.removeItem('userRole');
    navigate('/');
  };

  const userRole = localStorage.getItem('userRole');
  const isCandidate = userRole === 'candidate' || (!userRole && location.pathname.startsWith('/jobs'));
  const isEmployee = userRole === 'employee' || location.pathname.startsWith('/employee-dashboard');

  let user = {
    name: 'Admin User',
    role: 'HR Manager',
    avatar: 'https://i.pravatar.cc/150?img=11'
  };

  if (isCandidate) {
    user = {
      name: 'Yaw Mensah',
      role: 'Candidate',
      avatar: 'https://images.unsplash.com/photo-1520341280432-4749d4d7bcf9?ixlib=rb-4.0.3&auto=format&fit=crop&w=150&q=80'
    };
  } else if (isEmployee) {
    user = {
      name: 'Samuel Boateng',
      role: 'Logistics Coordinator',
      avatar: 'https://i.pravatar.cc/150?img=12'
    };
  }

  return (
    <header className="sticky top-0 z-10 w-full bg-white/80 backdrop-blur-md border-b border-gray-100 shadow-sm transition-all duration-300 px-4 sm:px-6 h-16 flex items-center justify-between">
      <div className="flex items-center gap-4 flex-1">
        <button onClick={toggleSidebar} className="lg:hidden text-gray-500 hover:text-[#11469A] transition-colors p-2 -ml-2 rounded-lg hover:bg-gray-50">
          <SafeIcon name="Menu" size={24} />
        </button>
        <button onClick={toggleCollapse} className="hidden lg:block text-gray-500 hover:text-[#11469A] transition-colors p-2 -ml-2 rounded-lg hover:bg-gray-50">
          <SafeIcon name={isCollapsed ? "Menu" : "AlignLeft"} size={20} />
        </button>

        <div className="hidden sm:flex items-center bg-gray-50 rounded-full px-4 py-2 border border-transparent focus-within:border-[#11469A]/30 focus-within:bg-white transition-all w-64 lg:w-80">
          <SafeIcon name="Search" size={18} className="text-gray-400" />
          <input type="text" placeholder="Search..." className="bg-transparent border-none outline-none ml-2 text-sm w-full text-gray-700 placeholder-gray-400" />
        </div>
      </div>

      <div className="flex items-center gap-2 sm:gap-4 relative">
        <button className="p-2 text-gray-400 hover:text-[#11469A] transition-colors rounded-full hover:bg-gray-50 relative">
          <SafeIcon name="Bell" size={20} />
          <span className="absolute top-1.5 right-1.5 w-2 h-2 bg-red-500 rounded-full border-2 border-white"></span>
        </button>

        <div className="h-6 w-px bg-gray-200 mx-1 hidden sm:block"></div>

        <button className="flex items-center gap-3 pl-2 sm:pl-0 focus:outline-none" onClick={() => setProfileOpen(!profileOpen)}>
          <div className="text-right hidden sm:block">
            <p className="text-sm font-semibold text-gray-700 leading-none">{user.name}</p>
            <p className="text-xs text-gray-500 mt-1">{user.role}</p>
          </div>
          <div className="w-9 h-9 rounded-full bg-[#11469A]/10 border border-[#11469A]/20 flex items-center justify-center overflow-hidden relative">
            <img src={user.avatar} alt="Profile" className="w-full h-full object-cover" />
          </div>
        </button>

        {profileOpen && (
          <>
            <div className="fixed inset-0 z-40" onClick={() => setProfileOpen(false)}></div>
            <div className="absolute right-0 top-12 mt-2 w-48 bg-white rounded-lg shadow-lg border border-gray-100 py-1 z-50 animate-in fade-in slide-in-from-top-2 duration-200">
              <div className="px-4 py-3 border-b border-gray-100 sm:hidden">
                <p className="text-sm font-semibold text-gray-800">{user.name}</p>
                <p className="text-xs text-gray-500">{user.role}</p>
              </div>
              <Link to="/profile" className="flex items-center gap-2 px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 hover:text-[#11469A] transition-colors" onClick={() => setProfileOpen(false)}>
                <SafeIcon name="User" size={16} /> My Profile
              </Link>
              {!isCandidate && !isEmployee && (
                <Link to="/settings" className="flex items-center gap-2 px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 hover:text-[#11469A] transition-colors" onClick={() => setProfileOpen(false)}>
                  <SafeIcon name="Settings" size={16} /> Settings
                </Link>
              )}
              <div className="h-px bg-gray-100 my-1"></div>
              <button onClick={handleLogout} className="w-full flex items-center gap-2 px-4 py-2 text-sm text-red-600 hover:bg-red-50 transition-colors">
                <SafeIcon name="LogOut" size={16} /> Logout
              </button>
            </div>
          </>
        )}
      </div>
    </header>
  );
};

export default Header;